import React from 'react';
import { createSvgIcon } from '@mui/material/utils';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Utility function to convert a provided svg path into an icon that can be controlled
 * via props. Uses MUI's createSvgIcon under the hood.
 */
export var createZenithIcon = function createZenithIcon(path, displayName) {
  var Svg = createSvgIcon(path, displayName);
  return function (_ref) {
    var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'inherit' : _ref$color;
    return /*#__PURE__*/_jsx(Svg, {
      fontSize: "inherit",
      htmlColor: color
    });
  };
};